import Store from 'store'

let token = Store.get('authToken') || false
let loggedIn = typeof token === 'string'

export function isLoggedIn(state = loggedIn, action) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return true

    case 'LOGOUT':
      return false

    default:
      return state
  }
}

export function authToken(state = token, action) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return action.authToken

    case 'UPDATE_AUTHTOKEN':
      return action.authToken

    case 'LOGOUT':
      return false

    default:
      return state
  }
}

export function loginError(state = false, action) {
  switch (action.type) {
    case 'LOGIN_FAIL':
      return action.message || 'Login fail'
    default:
      return state
  }
}

export function authUser(state = false, action) {
  switch (action.type) {
    case 'SET_AUTH_USER':
      return action.user
    default:
      return state
  }
}

export function authUserLoading(state = false, action) {
  switch (action.type) {
    case 'AUTH_USER_LOADING':
      return action.loading || false
    default:
      return state
  }
}

export function authUserError(state = false, action) {
  switch (action.type) {
    case 'SET_AUTH_USER_ERROR':
      return action.message || 'Error when getting authenticated user'
    default:
      return state
  }
}
